const appId = "130be11a-3569-49d1-a34e-8f5ea8d71e65";
const tid = "7c3e4bc5-2339-4622-8feb-47d86d4b5c90";
const config = {
  appId,
  redirectUri: window.location.href.split("glamurlshortenerapplication")[0],
  scopes: ["user.read"],
  authority: `https://login.microsoftonline.com/${tid}`,
};
export default config;
